import { useMemo } from 'preact/hooks';

import { useViewportType } from './useViewportType';

export const useComputedStyle = (element?: Element) => {
  const { viewport } = useViewportType();

  return useMemo(() => {
    return element ? getComputedStyle(element) : undefined;
  }, [element, viewport]);
};
